import { isAdmin } from '../../util/authentication'
import type { UserDetailType } from '../../reducer/user.reducer'

/** Compile-time gate — safe to read on first paint. */
export const isAiAssistantFeatureFlagOn =
    import.meta.env.VITE_AI_ASSISTANT === 'true' ||
    /** @deprecated legacy screener-only flag; same as VITE_AI_ASSISTANT */
    import.meta.env.VITE_SCREENER_AI_V2 === 'true'

const AI_ASSISTANT_ADMIN_CACHE_KEY = 'tick2trade-ai-assistant-admin-cache'

function readAdminCache(): boolean | null {
    if (typeof window === 'undefined') return null
    const raw = window.sessionStorage.getItem(AI_ASSISTANT_ADMIN_CACHE_KEY)
    if (raw === 'true') return true
    if (raw === 'false') return false
    return null
}

export function cacheAiAssistantAdminAccess(isAdminUser: boolean): void {
    if (typeof window === 'undefined') return
    window.sessionStorage.setItem(AI_ASSISTANT_ADMIN_CACHE_KEY, String(isAdminUser))
}

/** Full gate for opening / using the assistant (requires loaded profile + admin). */
export function isAiAssistantEnabled(user: UserDetailType | undefined | null): boolean {
    if (!isAiAssistantFeatureFlagOn) return false
    return isAdmin(user?.currentUser)
}

/**
 * Sidebar visibility — admin-only; never show the icon until profile confirms access.
 */
export function shouldShowAiAssistantInSidebar(user: UserDetailType | undefined | null): boolean {
    if (!isAiAssistantFeatureFlagOn) return false
    const currentUser = user?.currentUser
    if (currentUser) {
        const allowed = isAdmin(currentUser)
        cacheAiAssistantAdminAccess(allowed)
        return allowed
    }
    const cached = readAdminCache()
    if (cached !== null) return cached
    return false
}
